(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["21ph-contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ph-contact]').forEach(function (root) {
    if (root.dataset.contactReady === 'true') return;
    root.dataset.contactReady = 'true';

    var seriesSel = root.querySelector('[data-ph-series]');
    var textureSel = root.querySelector('[data-ph-texture]');
    var holder = document.querySelector('[data-ph-catalog]');
    var catalog = {};

    if (holder) {
      try { catalog = JSON.parse(holder.textContent); } catch (e) { catalog = {}; }
    }

    function fillTextures() {
      if (!seriesSel || !textureSel) return;
      var list = catalog[seriesSel.value] || [];

      textureSel.innerHTML = '';

      if (!list.length) {
        var none = document.createElement('option');
        none.value = '';
        none.textContent = seriesSel.value ? 'Any texture in this series' : 'Select a series first';
        textureSel.appendChild(none);
        textureSel.disabled = !seriesSel.value;
        return;
      }

      var any = document.createElement('option');
      any.value = '';
      any.textContent = 'Any texture in this series';
      textureSel.appendChild(any);

      list.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        textureSel.appendChild(opt);
      });

      textureSel.disabled = false;
    }

    if (seriesSel) {
      seriesSel.addEventListener('change', fillTextures);
      fillTextures();
    }

    /* Native submit on purpose — see the comment at the top of this file. */
    var ok = root.querySelector('[data-ph-ok]');
    if (ok) {
      window.setTimeout(function () {
        ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 150);
    }

    var form = root.querySelector('form');
    var btn = root.querySelector('[data-ph-submit]');
    if (form && btn) {
      form.addEventListener('submit', function () {
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
        btn.disabled = true;
        btn.textContent = 'Sending…';
      });
    }

    /* Click-to-load keeps a third-party frame off the critical path, and gives
       visitors behind a firewall something to read instead of a blank box. */
    var mapLoad = root.querySelector('[data-ph-map-load]');
    if (mapLoad) {
      mapLoad.addEventListener('click', function () {
        var frame = root.querySelector('[data-ph-map-frame]');
        if (!frame) return;
        var wrap = document.createElement('div');
        wrap.innerHTML = frame.dataset.mapEmbed || '';
        var iframe = wrap.querySelector('iframe');
        if (!iframe) return;
        iframe.setAttribute('loading', 'lazy');
        iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
        iframe.setAttribute('title', frame.dataset.mapTitle || 'Our location');
        frame.appendChild(iframe);
        mapLoad.hidden = true;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["21ph-downloads"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ph-downloads]').forEach(function (root) {
    /* Submission is a plain native POST on purpose: Shopify injects its CAPTCHA
       token during that flow, so intercepting with fetch strips the token and
       the request is rejected. This only tidies up after Shopify reloads. */
    root.querySelectorAll('[data-ph-card]').forEach(function (card) {
      var served = card.querySelector('[data-ph-server-ok]');
      if (!served) return;

      /* Hide the spent inputs only. The confirmation and the download button
         live inside the same form element, so hiding the form would take them
         down with it. */
      ['.ph-downloads__gate-note', '.ph-downloads__fields', '[data-ph-submit]'].forEach(function (sel) {
        var el = card.querySelector(sel);
        if (el) el.hidden = true;
      });

      /* No programmatic click: a scripted click on a target="_blank" link is
         treated as a popup and blocked. Surface the button instead. */
      window.setTimeout(function () {
        served.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var link = card.querySelector('.ph-downloads__btn--ready');
        if (link) link.focus({ preventScroll: true });
      }, 300);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["21ph-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ph-faq]').forEach(function (root) {
    if (root.dataset.faqReady === 'true') return;
    root.dataset.faqReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ph-item]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ph-tab]'));
    var search = root.querySelector('[data-ph-search]');
    var empty = root.querySelector('[data-ph-empty]');
    var cat = 'all';

    function apply() {
      var term = (search && search.value || '').trim().toLowerCase();
      var shown = 0;

      items.forEach(function (item) {
        var matchCat = cat === 'all' || item.dataset.phCat === cat;
        var matchTerm = !term || item.textContent.toLowerCase().indexOf(term) !== -1;
        var visible = matchCat && matchTerm;
        item.hidden = !visible;
        /* Collapse anything filtered out so a stale open panel does not
           reappear when the visitor clears the search. */
        if (!visible) item.open = false;
        if (visible) shown += 1;
      });

      if (empty) empty.hidden = shown !== 0;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        cat = tab.dataset.phTab;
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        apply();
      });
    });

    if (search) {
      search.addEventListener('input', apply);
      search.addEventListener('search', apply);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["21ph-floating-contact"]) return;
  try {
    
  document.querySelectorAll('[data-ph-fab]').forEach(function (fab) {
    if (fab.dataset.fabReady === 'true') return;
    fab.dataset.fabReady = 'true';

    var toggle = fab.querySelector('[data-ph-fab-toggle]');
    var stack = fab.querySelector('[data-ph-fab-stack]');
    if (!toggle || !stack) return;

    function setOpen(open) {
      stack.hidden = !open;
      fab.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      setOpen(stack.hidden);
    });

    /* Dismiss on outside click — a stack left open would cover page content
       on every subsequent scroll. */
    document.addEventListener('click', function (event) {
      if (!stack.hidden && !fab.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !stack.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["21ph-information-article"]) return;
  try {
    
  document.querySelectorAll('[data-ph-post]').forEach(function (post) {
    if (post.dataset.postReady === 'true') return;
    post.dataset.postReady = 'true';

    var bar = post.querySelector('[data-ph-progress]');
    var body = post.querySelector('.ph-post__body');
    if (!bar || !body) return;

    function update() {
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      if (total <= 0) { bar.style.width = '0%'; return; }
      var passed = Math.min(Math.max(-rect.top, 0), total);
      bar.style.width = (passed / total * 100) + '%';
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["21ph-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ph-product-detail]').forEach(function (root) {
    if (root.dataset.galleryReady === 'true') return;
    root.dataset.galleryReady = 'true';

    var mainImage = root.querySelector('[data-gallery-main-image]')
      || root.querySelector('.ph-product-gallery__main-image');
    var thumbnails = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    var previous = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');

    if (!mainImage || thumbnails.length < 2) return;

    function showImage(index) {
      var safeIndex = (index + thumbnails.length) % thumbnails.length;
      var thumbnail = thumbnails[safeIndex];

      /* Preload first, then swap. Fading out before the new file has arrived
         is what produces the blank flash between images. */
      var nextSrc = thumbnail.dataset.imageSrc;
      var preloader = new Image();
      preloader.onload = function () {
        mainImage.src = nextSrc;
        mainImage.alt = thumbnail.dataset.imageAlt || '';
        mainImage.classList.remove('is-changing');
      };
      preloader.onerror = function () {
        mainImage.classList.remove('is-changing');
      };
      mainImage.classList.add('is-changing');
      preloader.src = nextSrc;

      thumbnails.forEach(function (item, itemIndex) {
        var active = itemIndex === safeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    /* Warm the cache for every gallery image once the page is idle, so the
       first click on any thumbnail is instant rather than a fresh download. */
    var warm = function () {
      thumbnails.forEach(function (thumbnail) {
        var img = new Image();
        img.src = thumbnail.dataset.imageSrc;
      });
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warm);
    } else {
      window.setTimeout(warm, 1200);
    }

    thumbnails.forEach(function (thumbnail, index) {
      thumbnail.addEventListener('click', function () {
        showImage(index);
      });
    });

    if (previous) {
      previous.addEventListener('click', function () {
        var index = thumbnails.findIndex(function (item) {
          return item.classList.contains('is-active');
        });
        showImage(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        var index = thumbnails.findIndex(function (item) {
          return item.classList.contains('is-active');
        });
        showImage(index + 1);
      });
    }
  });
  document.querySelectorAll('.ph-product-detail').forEach(function (root) {
    if (root.dataset.lightboxReady === 'true') return;

    var mainImage = root.querySelector('[data-gallery-main-image]')
      || root.querySelector('.ph-product-gallery__main-image');
    if (!mainImage) return;

    root.dataset.lightboxReady = 'true';

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var sources = thumbs.map(function (t) {
      return { src: t.dataset.imageSrc, alt: t.dataset.imageAlt || '' };
    });

    /* A product with a single image still deserves the enlarged view, so fall
       back to whatever the stage is currently showing. */
    if (!sources.length) {
      sources = [{ src: mainImage.currentSrc || mainImage.src, alt: mainImage.alt || '' }];
    }

    var index = 0;
    var lastFocus = null;

    var box = document.createElement('div');
    box.className = 'ph-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', root.dataset.labelEnlargedImage);
    box.setAttribute('dir', 'ltr');
    box.innerHTML =
      '<figure class="ph-lightbox__figure">' +
        '<button class="ph-lightbox__close" type="button" aria-label="">&times;</button>' +
        '<button class="ph-lightbox__nav ph-lightbox__nav--prev" type="button" aria-label="">&lsaquo;</button>' +
        '<img class="ph-lightbox__image" alt="">' +
        '<button class="ph-lightbox__nav ph-lightbox__nav--next" type="button" aria-label="">&rsaquo;</button>' +
        '<figcaption class="ph-lightbox__counter"></figcaption>' +
      '</figure>';
    document.body.appendChild(box);

    var img = box.querySelector('.ph-lightbox__image');
    var closeBtn = box.querySelector('.ph-lightbox__close');
    var prevBtn = box.querySelector('.ph-lightbox__nav--prev');
    var nextBtn = box.querySelector('.ph-lightbox__nav--next');
    var counter = box.querySelector('.ph-lightbox__counter');
    closeBtn.setAttribute('aria-label', root.dataset.labelClose);
    prevBtn.setAttribute('aria-label', root.dataset.labelPreviousImage);
    nextBtn.setAttribute('aria-label', root.dataset.labelNextImage);

    var single = sources.length < 2;
    prevBtn.hidden = single;
    nextBtn.hidden = single;
    counter.hidden = single;

    function show(i) {
      index = (i + sources.length) % sources.length;
      img.src = sources[index].src;
      img.alt = sources[index].alt;
      counter.textContent = (index + 1) + ' / ' + sources.length;
    }

    function open() {
      /* Start from whichever thumbnail is currently active so the enlarged view
         matches what the visitor was already looking at. */
      var active = root.querySelector('[data-gallery-thumb].is-active');
      var start = active ? thumbs.indexOf(active) : 0;

      lastFocus = document.activeElement;
      show(start < 0 ? 0 : start);
      box.classList.add('is-open');
      document.body.classList.add('ph-lightbox-open');
      window.requestAnimationFrame(function () { box.classList.add('is-visible'); });
      closeBtn.focus();
    }

    function close() {
      box.classList.remove('is-visible');
      document.body.classList.remove('ph-lightbox-open');
      window.setTimeout(function () { box.classList.remove('is-open'); }, 220);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    mainImage.addEventListener('click', open);

    closeBtn.addEventListener('click', close);
    img.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });

    box.addEventListener('click', function (event) {
      if (event.target === box || event.target.classList.contains('ph-lightbox__figure')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (!box.classList.contains('is-open')) return;
      if (event.key === 'Escape') close();
      if (single) return;
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["21ph-video-library"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ph-videos]').forEach(function (root) {
    if (root.dataset.videosReady === 'true') return;
    root.dataset.videosReady = 'true';

    var tabs = Array.from(root.querySelectorAll('[data-ph-tab]'));
    var cards = Array.from(root.querySelectorAll('[data-ph-category]'));
    var empty = root.querySelector('[data-ph-empty]');

    function stop(card) {
      /* Swapping tabs while a video plays would leave audio running in a
         hidden card, so tear the iframe down and restore the poster. */
      var frame = card.querySelector('[data-ph-frame]');
      var poster = card.querySelector('[data-ph-play]');
      if (frame && frame.firstChild) {
        frame.innerHTML = '';
        frame.hidden = true;
      }
      if (poster) poster.hidden = false;
    }

    function showCategory(name) {
      var visible = 0;
      cards.forEach(function (card) {
        var match = card.dataset.phCategory === name;
        if (!match) stop(card);
        card.hidden = !match;
        if (match) visible += 1;
      });
      tabs.forEach(function (tab) {
        var active = tab.dataset.phTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (empty) empty.hidden = visible !== 0;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        showCategory(tab.dataset.phTab);
      });
    });

    root.querySelectorAll('[data-ph-play]').forEach(function (poster) {
      poster.addEventListener('click', function () {
        var card = poster.closest('[data-ph-category]');
        var frame = card.querySelector('[data-ph-frame]');
        var id = poster.dataset.videoId;
        if (!frame || !id) return;

        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0');
        iframe.setAttribute('title', poster.getAttribute('aria-label') || 'Video');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.cssText = 'width:100%;height:100%;position:absolute;inset:0;border:0;';

        frame.appendChild(iframe);
        frame.hidden = false;
        poster.hidden = true;
      });
    });

    showCategory('installation');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
